import React from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';

import ClientDomainStore from '../../stores/ClientDomainStore';
import Loading from '../Loading';
import Search from '../../util/Search';
import ServiceActions from '../../actions/ServiceActions';
import UserStore from '../../stores/UserStore';

function getState() {
    const domains = ClientDomainStore.get();

    return {
        domains: domains,
        loadedDomainCount: ClientDomainStore.get().length,
        loading: !ClientDomainStore.has(),
    };
}

const DomainTable = React.createClass({
    propTypes: {
        widgetName: React.PropTypes.string.isRequired
    },
    getDefaultProps: function () {
        return {
            allowSearch: false
        }
    },
    getInitialState: function () {
        return {search: '', ...getState()};
    },
    componentDidMount: function() {
        ClientDomainStore.addChangeListener(this._onChange);
        UserStore.addChangeListener(this.componentWillMount);
    },
    componentWillMount: function () {
        const user = UserStore.getUser();

        if (user && !ClientDomainStore.has() && !ClientDomainStore.loading()) {
            ServiceActions.getServices(user);
        }
    },
    componentWillUnmount: function () {
        ClientDomainStore.removeChangeListener(this._onChange);
        UserStore.removeChangeListener(this.componentWillMount);
    },
    filterValueChanged: function (e) {
        this.setState({search: e.target.value});
    },
    renderDomains: function () {
        if (this.state.loading) {
            return <tbody><tr><td colSpan="2"><Loading /></td></tr></tbody>;
        }

        if (this.state.loadedDomainCount === 0) {
            return <tbody><tr><td colSpan="2">
                You have no current domains.
            </td></tr></tbody>;
        }

        let rows = this.state.domains.map((domain) => {
            if (!Search.isMatch(this.state.search, domain.domain)) {
                return null;
            }

            return <tr key={domain.domain}>
              <td>{domain.domain}</td>
              <td>{domain.expires ? moment(domain.expires).format(_DATE_FORMAT) : ''}</td>
            </tr>
        }).filter(row => !!row);

        return <tbody>{rows}</tbody>;
    },
    render: function () {
        const header = <tr>
            <th>Domain</th>
            <th>Expires</th>
        </tr>;

        let filter, footerHeader;

        if (this.state.loadedDomainCount > 5) {
            if (this.props.allowSearch) {
                filter = <div className="dataTables_filter">
                    <label>Search: <input ref="filter" className="form-control" value={this.state.search} onChange={this.filterValueChanged} /></label>
                </div>;
            }

            footerHeader = <tfoot>{header}</tfoot>;
        }

        return <section className="powerwidget green clientService-table">
            <header><h2>{this.props.widgetName}</h2></header>
            <div className="inner-spacer">
                <div className="callout callout-info">
                    <p>To manage or renew your domains, head over to our <a href="https://infinite.partnerconsole.net/" target="_blank">domains portal</a>.</p>
                </div>
                {filter}
                <div className="table-responsive">
                    <Table className="table-striped table-hover">
                        <thead>{header}</thead>
                        {this.renderDomains()}
                        {footerHeader}
                    </Table>
                </div>
            </div>
        </section>;
    },
    _onChange: function () {
        this.setState(getState());
    }
});

module.exports = DomainTable;



// WEBPACK FOOTER //
// ./app/components/Domain/Table.js